import store from 'store/store';
import './middlewares/panels';
import './middlewares/overlay';
import './middlewares/header';
export default store;
